module.exports = __webpack_public_path__ + "media/src/images/icons/retweet-ea27ec0eec78f9a0c585b938e1579100.svg";